class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    //reloadswiper();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    reloadSlickSlider();
    // reloadswiper();
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// function reloadSlickSlider() {
//   if (window.jQuery && typeof jQuery.fn.slick === 'function') {
//     jQuery('.complemantory-product-list').not('.slick-initialized').slick({
//       slidesToShow: 1.32,
//       slidesToScroll: 1,
//       autoplay: false,
//       infinite: false,
//       autoplaySpeed: 2000,
//       prevArrow: '',
//       nextArrow: ''
//     });
//   } else {
//     console.error('jQuery or Slick is not loaded.');
//   }
// }

// // Optional: Call it on DOMContentLoaded
// document.addEventListener('DOMContentLoaded', reloadSlickSlider);


/* ===========================
   Gift + Overlays + Guards
   =========================== */
  (() => {
  const giftVariantId = 52841202614602;
  const sleep = (ms) => new Promise(r => setTimeout(r, ms));


  async function refreshCartDrawer() {
  // Obtener los datos actuales del carrito
  const cart = await fetch('/cart.js').then(r => r.json());

  // Obtener el HTML actualizado para la sección del drawer
  const sectionHtml = await fetch('/?section_id=cart-drawer').then(r => r.text());
  const parser = new DOMParser();
  const doc = parser.parseFromString(sectionHtml, 'text/html');

  // Primero, ver si el tema usa el componente <cart-drawer>
  const newCartDrawerElem = doc.querySelector('cart-drawer');
  const currentCartDrawerElem = document.querySelector('cart-drawer');

  if (newCartDrawerElem && currentCartDrawerElem) {
    currentCartDrawerElem.replaceWith(newCartDrawerElem);

    // Reabrirlo si estaba abierto
    if (newCartDrawerElem.hasAttribute('open')) {
      newCartDrawerElem.open();
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    console.log('✅ Cart Drawer actualizado (componente moderno)');
    return;
  }

  // Si no, usar la versión antigua con #CartDrawer
  const newOldDrawer = doc.querySelector('#CartDrawer');
  const currentOldDrawer = document.querySelector('#CartDrawer');

  if (newOldDrawer && currentOldDrawer) {
    currentOldDrawer.replaceWith(newOldDrawer);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    console.log('✅ Cart Drawer actualizado (versión antigua)');
    return;
  }

  console.warn('⚠️ No se encontró el cart drawer para actualizarlo');
}
  // 🧩 --- REFRESH DRAWER FUNC ---
  async function refreshCartDrawerContents() {
    console.log('🔄 Iniciando refreshCartDrawerContents()...');

    const response = await fetch('/?section_id=cart-drawer');
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newDrawer = doc.querySelector('cart-drawer, #CartDrawer');
    const currentDrawer = document.querySelector('cart-drawer, #CartDrawer');
    if (!newDrawer || !currentDrawer) return;

    const newCartItems = newDrawer.querySelector('cart-drawer-items');
    const isEmpty = newCartItems?.classList.contains('is-empty');
    const newInner = newDrawer.querySelector('.drawer__inner');
    const currentInner = currentDrawer.querySelector('.drawer__inner');

    if (!isEmpty && newInner) {
      currentInner.innerHTML = newInner.innerHTML;
      currentDrawer.classList.remove('is-empty');
    } else {
      currentInner.innerHTML = newInner.innerHTML;
      currentDrawer.classList.add('is-empty');
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
    console.log('🏁 refreshCartDrawerContents() completado.');
    //reloadswiper();
  }

  // 🧠 --- VALIDACIÓN LOCAL DE INPUTS ---
  function setupQuantityValidation() {
    document.addEventListener("keydown", (e) => {
      const input = e.target.closest("input.quantity__input");
      if (!input) return;
      if (e.key === "-") e.preventDefault();
    });

    document.addEventListener("blur", (e) => {
      const input = e.target.closest("input.quantity__input");
      if (!input) return;
      const val = parseInt(input.value, 10);
      if (isNaN(val) || val <= 0) {
        input.value = 1;
        input.dispatchEvent(new Event("input", { bubbles: true }));
        console.warn("🚫 Valor inválido → restaurado a 1");
      }
    }, true);
  }

  // 🚫 --- BLOQUEAR ENTER CUANDO CART ESTÁ ABIERTO ---
  function disableEnterWhenCartOpen() {
    document.addEventListener("keydown", (e) => {
      const drawer = document.querySelector("cart-drawer, #CartDrawer");
      const isOpen = drawer?.classList.contains("active") || drawer?.hasAttribute("open");
      const input = e.target.closest("input.quantity__input");

      // Solo bloquear Enter si el drawer está visible y el foco está en un input
      if (isOpen && e.key === "Enter" && input) {
        e.preventDefault();
        console.warn("🚫 Enter deshabilitado mientras el carrito está abierto");
      }
    });
  }

  // 🚫 --- BLOQUEAR CHECKOUT CON SOLO GIFT O CANTIDAD INVÁLIDA ---
  async function validateBeforeCheckout(e) {
    const btn = e.target.closest("#CartDrawer-Checkout");
    if (!btn) return;

    const cart = await fetch("/cart.js").then(r => r.json());
    const hasGift = cart.items.some(i => i.id === giftVariantId);
    const nonGift = cart.items.filter(i => i.id !== giftVariantId);
    const invalidQty = cart.items.some(i => i.quantity <= 0);

    if ((hasGift && nonGift.length === 0) || invalidQty) {
      e.preventDefault();
      alert("No puedes finalizar la compra solo con el regalo o con cantidades inválidas.");
      console.warn("🚫 Checkout bloqueado");
      await refreshCartDrawerContents();
      return false;
    }
  }

  // 🧹 --- MANEJO DEL GIFT ---
// 🧹 --- MANEJO DEL GIFT ---
async function handleGiftLogic() {
  const cart = await fetch("/cart.js").then(r => r.json());
  const hasGift = cart.items.some(i => i.id === giftVariantId);
  const nonGift = cart.items.filter(i => i.id !== giftVariantId);

  // 🎁 Añadir si faltara
  if (nonGift.length > 0 && !hasGift) {
    console.log("🎁 Añadiendo regalo...");
    CartJS.addItem(giftVariantId, 1, {}, {
      success: async () => {
        console.log("✅ Regalo añadido correctamente");
        await sleep(200);
        await refreshCartDrawerContents();
      }
    });
    return;
  }

  // 🧨 Si solo queda el regalo → vaciar carrito correctamente
  if (hasGift && nonGift.length === 0) {
    console.warn("⚠️ Solo queda el regalo → vaciando carrito...");

    return new Promise((resolve) => {
      CartJS.clear({
        success: async () => {
          console.log("🧹 Carrito vaciado correctamente, cerrando drawer...");
          
          // Esperamos a que Shopify confirme el clear real
          await sleep(400);

          // 🧩 Cerrar y regenerar completamente el drawer
          await refreshCartDrawer();

          console.log("✅ Drawer regenerado post-clear");
          resolve();
        },
        error: async (err) => {
          console.error("❌ Error al vaciar el carrito:", err);
          await refreshCartDrawer();
          resolve();
        }
      });
    });
  }

  // ⚖️ Ajustar cantidad del gift a 1 si excede
  const giftItem = cart.items.find(i => i.id === giftVariantId);
  if (giftItem && giftItem.quantity > 1) {
    CartJS.updateItemById(giftVariantId, 1, {}, {
      success: async () => {
        console.log("♻️ Ajustando cantidad del regalo a 1");
        await sleep(200);
        await refreshCartDrawerContents();
      }
    });
  }
}

  // 🌐 --- INTERCEPTAR FETCH ---
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const [url, options] = args;
    const res = await originalFetch.apply(this, args);

    if (typeof url === "string" && (
      url.includes("/cart/add") ||
      url.includes("/cart/change") ||
      url.includes("/cart/update")
    )) {
      console.log("🌐 Fetch detectado:", url);
      await sleep(400);
      const cart = await fetch("/cart.js").then(r => r.json());

      // 🚫 Corregir si hay quantity 0 (caso Enter móvil)
      for (const item of cart.items) {
        if (item.quantity <= 0) {
          console.warn(`🚫 Corrigiendo cantidad 0 de ${item.id}`);
          CartJS.updateItemById(item.id, 1);
        }
      }

      await handleGiftLogic();
      await refreshCartDrawerContents();
      setupQuantityValidation();
    }

    return res;
  };

  // 🖱️ --- ELIMINACIÓN MANUAL ---
 document.addEventListener("click", async (e) => {
  const btn = e.target.closest("cart-remove-button button, cart-remove-button a");
  if (!btn) return;

  const cart = await fetch("/cart.js").then(r => r.json());
  const hasGift = cart.items.some(i => i.id === giftVariantId);
  const nonGift = cart.items.filter(i => i.id !== giftVariantId);

  // 🧩 Si hay solo un producto + gift → vaciar completamente
  if (hasGift && nonGift.length === 1 && cart.items.length === 2) {
    e.preventDefault();
    console.log("🧩 Último producto + regalo → vaciando todo el carrito...");

    CartJS.clear({
      success: async () => {
        console.log("🧹 Carrito vaciado correctamente, regenerando drawer...");
        await sleep(800); // espera a que Shopify actualice el carrito realmente
        await refreshCartDrawerContents();
      },
      error: async (err) => {
        console.error("❌ Error al vaciar el carrito:", err);
        await refreshCartDrawerContents();
      }
    });

    return;
  }
});

  // 🚀 --- INICIALIZAR ---
  document.addEventListener("DOMContentLoaded", async () => {
    console.log("🚀 Script Cart Drawer inicializado");
    await handleGiftLogic();
    await refreshCartDrawerContents();
    setupQuantityValidation();
    disableEnterWhenCartOpen();
  });

  document.addEventListener("click", validateBeforeCheckout);
})();
